import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/constants/landingAssets";

const IMG_MAP = {
  hero: IMAGES.hero,
  workflow: IMAGES.workflow,
  aiVisual: IMAGES.aiVisual,
};

export default function ScreenshotsSection({ t, navigate }) {
  if (!t.screenshots) return null;

  return (
    <section className="py-20 bg-white" data-testid="screenshots-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900">{t.screenshots.title}</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mb-14">
          {t.screenshots.items.map((item, i) => (
            <div key={i} className="group" data-testid={`screenshot-${item.key}`}>
              <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm group-hover:shadow-md transition-shadow mb-4">
                <img
                  src={IMG_MAP[item.key]}
                  alt={item.label}
                  className="w-full object-cover object-top"
                  style={{ maxHeight: "220px" }}
                />
              </div>
              <div className="px-1">
                <span className="inline-block text-xs font-bold text-[#CDA34F] uppercase tracking-wider mb-1 bg-[#CDA34F]/10 px-2 py-0.5 rounded">
                  {item.label}
                </span>
                <p className="text-sm text-gray-600 font-medium">{item.caption}</p>
              </div>
            </div>
          ))}
        </div>
        {navigate && (
          <div className="text-center">
            <Button
              onClick={() => navigate("/login")}
              className="h-14 px-10 bg-[#CC0000] hover:bg-[#a30000] text-white font-bold text-base uppercase tracking-wide rounded-lg"
              data-testid="screenshots-mid-cta"
            >
              {t.hero.cta1} <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <p className="text-sm text-gray-500 mt-3">{t.hero.noCc}</p>
          </div>
        )}
      </div>
    </section>
  );
}
